import {React} from "react";
import './Callback.scss'

const FinalPage= () => {
    return ( 
        <div className="callback">
            <div className="callbackContent">
                <div className='tiklock'></div>
                <span className="lblResultDes">سفارش شما در سیستم ثبت شد، همکاران ما در اولین فرصت با شما تماس خواهند گرفت</span>
            </div>
        </div>
     );
}

export default FinalPage;
